import { DataModel } from "common/models/utility-models/base-model";

export class TypesModel extends DataModel {
    typeId?:any='';
    type_name: any = "";
    categoryCount: cat | any = [];
    catId: any='';
    catActive:any = '';

}

export class cat {
    id: any[] = [];
    typeId?: "";
    isActive: number;
    delete_flag: "";
    isDeletable: ""
}

export class postCat {
    categories: any[] = [];
    type_name: "";
}